import { createActionGroup } from '@ngrx/store';

export const EspaceActions = createActionGroup({
  source: 'Espace',
  events: {}
});
